<template>
  <SogPage
    id="page"
    title="VB-Recherche"
  >
    <template #top>
      <SogCardActions :is-toolbar="true">
        <SogCardActionButton :kind="SogButtonKind.Back" />
      </SogCardActions>
    </template>
    <SogSkeleton v-show="loading" />
    <VbRechercheDetailsComponent
      v-if="!loading"
      :recherche-message="rechercheMessage"
    />
  </SogPage>
</template>

<script setup lang="ts">
import SogPage from "@/shared/ui/SogPage.vue";
import VbRechercheDetailsComponent from "../components/VbRechercheDetailsComponent.vue";
import RechercheMessage from "@/shared/model/RechercheMessage";
import apiVbRecherche from "@/modules/VbRecherche/api";

import {ref, watch} from "vue";
import SogSkeleton from "@/shared/ui/SogSkeleton.vue";
import getGuid from "@/shared/utils/getGuid";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import {SogButtonKind} from "@/shared/ui/types/SogButtonKind";

interface Props {
  evb?: string;
}

const props = withDefaults(defineProps<Props>(), {
  evb: undefined,
});

const loading = ref(true);

const _evb = ref("");
const _key = ref("");

watch(
  props,
  () => {
    _evb.value = props.evb ?? "";
  },
  {immediate: true}
);

watch(
  _evb,
  () => {
    _key.value = getGuid();
    loadMessage(_key.value);
  },
  {immediate: true}
);

async function loadMessage(key: string) {
  const res = await apiVbRecherche.load(_evb.value);

  if (key === _key.value) {
    if (res) {
      rechercheMessage.value = res;
    }
    loading.value = false;
  }
}

const rechercheMessage = ref<RechercheMessage>({
  versicherungsbestaetigungsnummer: "",
  vbStatusString: "unbekant",
} as RechercheMessage);
</script>

<style scoped></style>
